// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2C-O-","notes":"Notes_notes__2xECa"};